import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class LoginService {

    constructor(
        private _http: HttpClient
    ) {
    }
    
    loginSiteAdmin(payload) {
        return this._http.post<any>(`${environment.APIUrl}/api/auth/login/site-admin`, payload);
    }

    loginSubject(payload) {
        return this._http.post<any>(`${environment.APIUrl}/api/auth/login/subject`, payload);
    }
}
